import React, { Fragment, useEffect } from 'react';
import PlayerHeader from './PlayerHeader';
import Player from './Player';
import DevicesContext from '../utility/DevicesContext';
import { observable } from 'legacy-packages/ft-cb';

/**
 * Responsive player wrapper
 * uses ResponsiveView to decide what to display
 * based on the current device
 * */
const ResponsivePlayerWrapper = (props) => {
  const {
    timerInfo,
    title,
    pageTitle,
    isPreApSubject,
    fullScreen,
    fullName,
    timer,
    responsiveView: ResponsiveView,
    commonProps,
    isSoftTime,
    checkTimeExtension,
    checkTimeExtensionInterval,
    onTimerExpiring,
  } = props;

  /**
   * Add checkTimeExtension for not timed assignments as well.
   * For timed one the API is called in the timer component.
   * */
  useEffect(() => {
    const getInterval = () =>
      setInterval(() => {
        const { timeElapsed, totalTime } = timerInfo;
        if (
          !timer ||
          timeElapsed >= totalTime ||
          (timer && timeElapsed === 0)
        ) {
          checkTimeExtension();
        }
      }, checkTimeExtensionInterval);

    let assignmentSessionInterval = getInterval();

    /**
     * STOP THE COUNT after submission is successful. Continuining
     * to do this checkTimeExtension cheats the logic into thinking the time
     * for the assessment is done (which it techinically is) and shows the
     * auto-submission modal.
     *
     * NOTE: If it table >= 30seconds to receive submissionReady as true, this bug
     * will show up again: https://academicmerit.atlassian.net/browse/FY-21749
     */
    const observableCallback = (submissionReady) => {
      /**
       * To prevent a possible race-condition where the submission happens
       * and the time check happens before the observable notices it, let's
       * reset the timer when we recieve a submissionReady value of false which
       * tells us the user clicked "Submit" but learnosity hasn't confirmed yet if
       * the submission was successful.
       */
      if (!submissionReady) {
        clearInterval(assignmentSessionInterval);
        assignmentSessionInterval = getInterval();
      } else {
        /**
         * Then once we actually get told by LRN that the submission was successful
         * we clear the timeout
         */
        clearInterval(assignmentSessionInterval);
      }
    };
    observable.subscribe('submissionReady', observableCallback);

    return () => {
      clearInterval(assignmentSessionInterval);
    };
  });

  /**
   * If ResponsiveView is not sent we need to render the default
   * player
   * */
  return (
    <Fragment>
      <div className="PlayerModeContainer">
        <ResponsiveView screens={['desktop']}>
          {fullScreen && (
            <PlayerHeader
              isPreApSubject={isPreApSubject}
              pageTitle={pageTitle || title}
              timerInfo={timerInfo}
              isSoftTime={isSoftTime}
              fullName={fullName}
              timer={timer}
              checkTimeExtension={checkTimeExtension}
              checkTimeExtensionInterval={checkTimeExtensionInterval}
              onTimerExpiring={onTimerExpiring}
              {...commonProps}
            />
          )}
        </ResponsiveView>
        <DevicesContext.Provider value={{ responsiveView: ResponsiveView }}>
          <Player {...props} />
        </DevicesContext.Provider>
      </div>
    </Fragment>
  );
};

export default ResponsivePlayerWrapper;
